import React, { useEffect, useState } from "react";

export default function RuntimeModeCard() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchRuntimeStatus = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/api/runtime-status`,
          {
            cache: "no-store",
            headers: {
              "Cache-Control": "no-cache",
            },
          },
        );

        if (response.ok) {
          const result = await response.json();
          setData(result);
        } else {
          throw new Error("Failed to fetch runtime status");
        }
      } catch (err) {
        setError(err.message);
        console.error("Runtime status fetch error:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchRuntimeStatus();

    // Refresh every 30 seconds for real-time updates
    const interval = setInterval(fetchRuntimeStatus, 30000);
    return () => clearInterval(interval);
  }, []);

  if (loading) {
    return (
      <div className="rounded-2xl border p-4 shadow-sm">
        <h3 className="text-lg font-semibold mb-1">Runtime Mode</h3>
        <p className="text-gray-500">Loading...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="rounded-2xl border p-4 shadow-sm">
        <h3 className="text-lg font-semibold mb-1">Runtime Mode</h3>
        <p className="text-red-600">Error: {error}</p>
      </div>
    );
  }

  const isLive = data?.mode === "LIVE";

  return (
    <div className="rounded-2xl border p-4 shadow-sm">
      <h3 className="text-lg font-semibold mb-2">Runtime Mode</h3>
      <div className="space-y-2">
        <p
          className={`text-lg font-medium ${isLive ? "text-green-600" : "text-yellow-600"}`}
        >
          🚀 {isLive ? "LIVE" : "TEST"} Mode
        </p>
        <p className="text-sm text-gray-600">
          Notifications:{" "}
          {data?.notifications ? "✅ Configured" : "❌ Not configured"}
        </p>
        <p className="text-sm text-gray-600">
          P95 Target: {data?.p95_target_ms || 2000}ms
        </p>
        {data?.ts && (
          <p className="text-xs text-gray-500">
            Updated: {new Date(data.ts).toLocaleString()}
          </p>
        )}
      </div>
      <div className="mt-3">
        <a
          href={`${process.env.REACT_APP_BACKEND_URL}/api/runtime-status`}
          className="text-xs text-blue-600 underline hover:text-blue-800"
          target="_blank"
          rel="noopener noreferrer"
        >
          View Raw Runtime JSON
        </a>
      </div>
    </div>
  );
}
